// TODO: this module uses deprecated/non-standard browser features (Performance.timing, console.timestamp()); needs reworking
// - https://developer.mozilla.org/en-US/docs/Web/API/Performance/timing
// - https://developer.mozilla.org/en-US/docs/Web/API/console/timeStamp

/* eslint-disable @typescript-eslint/no-explicit-any */
export function mark(markName: string): void {
  window.performance && window.performance.mark && window.performance.mark(markName);
  console && (console as any)?.timeStamp(markName);
}

/**
 * Determine whether the given mark name is a navigation event and if it is, if it has occurred yet
 *
 * @param markName
 */
function navigationTimingMarkHit(markName: string): boolean {
  const timingMark = (window.performance && window.performance.timing && (window.performance.timing as any)[markName]) || null;
  return typeof timingMark !== 'undefined' && timingMark !== null;
}

export function getEntriesByType(entryType: string): PerformanceEntry[] {
  return (window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType(entryType)) || [];
}

export function getEntriesByName(entryName: string): PerformanceEntry[] {
  return (window.performance && window.performance.getEntriesByName && window.performance.getEntriesByName(entryName)) || [];
}

export function getTimingByName(name: string): number {
  return (window.performance && window.performance.timing && (window.performance as any).timing[name]) || null;
}

/**
 * Determine whether a mark can be safely passed to `measure`
 *
 * @param markName
 */
function canMeasureMark(markName: string): boolean {
  return navigationTimingMarkHit(markName) || getEntriesByName(markName).length > 0;
}

export function measure(measureName: string, startMarkName: string, endMarkName: string): void {
  if (window.performance && window.performance.measure) {
    if (!canMeasureMark(startMarkName) || !canMeasureMark(endMarkName)) {
      // Both marks need to exist, otherwise we cannot create a measure
      return;
    }

    window.performance.measure(measureName, startMarkName, endMarkName);
  }
}
